import { useState } from 'react';
import { History } from 'lucide-react';
import { ExportHistorySheet } from './ExportHistorySheet';
import './export-history.css';

/**
 * Export history's way in, in Job setup › Export beside "Send results to": one line on what it holds and Open, which
 * shows the sheet (ExportHistorySheet). Renders nothing when the workbench is not on a Paige job.
 */
export function ExportHistoryCard() {
  const bridge = window.paigeWorkbench;
  const [open, setOpen] = useState(false);
  if (!bridge?.exports) return null;
  return (
    <div className="setup-map-setting paige-export-history-card">
      <History size={22} aria-hidden="true" />
      <span>
        <strong>Export history</strong>
        <small>
          Every document sent to a destination: where it went, when, and what the destination said.
          Retry, cancel or send one back for review.
        </small>
        <span>
          <button type="button" className="secondary-button small" onClick={() => setOpen(true)}>
            Open export history
          </button>
        </span>
      </span>
      {open && <ExportHistorySheet bridge={bridge} onClose={() => setOpen(false)} />}
    </div>
  );
}
